import { render, staticRenderFns } from "./ProductRelated.vue?vue&type=template&id=17eb2bba"
import script from "./ProductRelated.vue?vue&type=script&lang=js"
export * from "./ProductRelated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProductCard: require('/vercel/path0/components/shared/ProductCard.vue').default,ContainerContent: require('/vercel/path0/components/shared/ContainerContent.vue').default})
